import { op as openpanel } from './config/openpanelConfig';

export const trackPageView = (pageName = '') => {
  if (openpanel) {
    try {
      openpanel.screenView(`/${pageName}`, {
        page: pageName,
        app: 'giotto',
      });
    } catch (error) {
      console.error('Error tracking page view in OpenPanel', error);
    }
  }
};
